import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { UserBO, DropList, DropList1, functionpermission, GetUserListBo } from './users.model';
import { ColumnChangeBO } from '../list/list.model';
import { ErrorService } from 'src/app/error.service';

@Injectable()
export class UsersHttpService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getUserList(): Observable<UserBO[]> {
    let url = "api/User/GetUser";
    return this.http.get<UserBO[]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  gettoltaliteam(paramsData: GetUserListBo): Observable<UserBO[]> {
    let url = "api/User/GetuserItem?";
    return this.http.post<UserBO[]>(url, paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  gettotalCount(paramsData: URLSearchParams): Observable<number> {
    let url = "api/User/user_Count?";
    return this.http.get<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getDropList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?";
    return this.http.get<DropList1[]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getStatusList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?";
    return this.http.get<DropList1[]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getUserRole(): Observable<DropList[]> {
    let url = "api/User/getRole";
    return this.http.get<DropList[]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getUserDropList(paramsData: URLSearchParams): Observable<DropList[]> {
    let url = "api/User/GetUserDropDown?";
    return this.http.get<DropList[]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getFilePermissions(paramsData: URLSearchParams): Observable<functionpermission> {
    let url = "api/functionpermisssion/getfunctionpermission?";
    return this.http.get<functionpermission>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getLocation(): Observable<any> {
    let url = "api/Location/GetLocationDropDownForUser";
    return this.http.get<functionpermission>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdateUser(saveList: UserBO): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    let url = "api/User/SaveUser";
    return this.http.post<number>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  updateUser(paramsData: UserBO): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      // observe:'response'
    };
    let url = "api/User/UpdateUser";
    return this.http.post<number>(url, paramsData, httpOptions).pipe(
      // map(data => data.body ),
      catchError(this.errorService.handleError)
    )
  }

  ResetPassword(paramsData: URLSearchParams): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      // observe:'response'
    };
    let url = "api/Auth/ResetPassword?";
    return this.http.post<number>(url + paramsData, httpOptions).pipe(
      catchError(this.errorService.handleError)
    )
  }

  deleteCareCoordinator(id: number): Observable<any> {
    let url = "api/CareCoordinator/DeleteCareCoordinator/" + id;
    return this.http.delete<number>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getcolumwidth(): Observable<any> {
    let url = "api/ColumnChange/getwidth?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  savecolumwidth(list: ColumnChangeBO): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<number>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getUserLoginRoles(params: URLSearchParams): Observable<DropList[]> {
    let url = "api/LoginRole/GetRolesDropdown?";
    return this.http.get<DropList[]>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}